import * as React from 'react';
import { observer } from 'mobx-react';
import { Button } from 'elc-buttons';
import { ContentSpacing } from 'elc-base-theme';
import styled from 'styled-components';
import * as classnames from 'classnames';

export interface ITagFilterButton {
    onFilterSelect(): void;
    isSelected: boolean;
    label: string;
    disabled?: boolean;
}

const StyledButton = styled(Button)`
    display: flex;
    margin-right: ${ContentSpacing.space24};
    margin-bottom: ${ContentSpacing.space16};

    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space24};
    }

    &.elc-button {
        padding-left: ${ContentSpacing.space20};
        padding-right: ${ContentSpacing.space20};
    }
`;

export const ButtonFilter = observer((props: ITagFilterButton) => {
    const className = classnames({
        'elc-styled-filters-category-button': true,
        'button--light': !props.isSelected,
        'button--dark': props.isSelected
    });

    return (
        <StyledButton
            className={className}
            onClick={props.onFilterSelect}
            disabled={props.disabled}
        >
            {props.label}
        </StyledButton>
    );
});
